import React from 'react';

import { Box } from '@mui/material';

interface IframeProps {
  iframeUrl?: string;
  iframeHeight?: string | number;
  iframeWidth?: string | number;
}

const Iframe: React.FC<IframeProps> = ({
  iframeUrl,
  iframeHeight,
  iframeWidth,
}) => {
  if (!iframeUrl) {
    return (
      <Box sx={{ padding: '20px', textAlign: 'center' }}>
        No URL provided for iframe
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <iframe
        src={iframeUrl}
        title="Embedded Content"
        height={iframeHeight || '500px'}
        width={iframeWidth || '100%'}
        style={{ border: 'none' }}
        allowFullScreen
      />
    </Box>
  );
};

export default Iframe;
